import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import EventCard from 'components/cards/entities/EventCard';
import Gallery from 'components/Gallery';
import Infographic from 'components/Infographic';
import LiveCard from 'components/cards/entities/LiveCard';
import MovieCard from 'components/cards/entities/MovieCard';
import OffsetSlider from 'components/sliders/OffsetSlider';
import ShowMore from 'components/cards/ShowMore';

import styles from './styles.module.scss';

const MediaBlockIncut = ({
	className,
	containerClassName,
	type,
	values,
	instituteName,
	instituteId
}) => {
	switch (type) {
		case 'tours':
			return (
				<Gallery
					key="tours"
					className={cx(styles.MediaBlockSlider, className)}
					containerClassName={containerClassName}
					materials={values}
					type="tours"
				/>
			);
		case 'infographic':
			return (
				<div key="infographic" className={containerClassName}>
					<Infographic image={values[0]} />
				</div>
			);
		case 'gallery':
			return (
				<Gallery
					key="gallery"
					className={cx(styles.MediaBlockSlider, className)}
					containerClassName={containerClassName}
					materials={values}
					withLightbox
				/>
			);
		case 'events':
			return (
				<OffsetSlider
					key="events"
					containerClassName={containerClassName}
					className={cx(styles.MediaBlockSlider, className)}
				>
					{values.map((event) => (
						<EventCard
							className={styles.MediaBlockIncutCard}
							entity={event}
							instituteId={instituteId}
							key={event._id}
						/>
					))}
				</OffsetSlider>
			);
		case 'performances':
			return (
				<OffsetSlider
					key="performances"
					containerClassName={containerClassName}
					className={cx(styles.MediaBlockSlider, className)}
				>
					{values.map((performance) => (
						<MovieCard
							key={performance._id}
							className={cx(
								styles.MediaBlockIncutCard,
								styles.MediaBlockIncutCard_vertical
							)}
							entity={performance}
							params={{ width: 211, height: 282 }}
						/>
					))}
				</OffsetSlider>
			);
		case 'broadcast':
			return (
				<OffsetSlider
					key="broadcast"
					containerClassName={containerClassName}
					className={cx(styles.MediaBlockSlider, className)}
				>
					{values.map((broadcastItem) => (
						<LiveCard
							key={broadcastItem._id}
							className={styles.MediaBlockIncutCard}
							entity={broadcastItem}
						/>
					))}
					{values.length === 10 && (
						<ShowMore
							url={`/live/archive/institute-${instituteName}?sort=-publishDate`}
							title="Все трансляции"
							type="cardLandscape"
							className={styles.MediaBlockIncutCard}
						/>
					)}
				</OffsetSlider>
			);
		default:
			return null;
	}
};

MediaBlockIncut.propTypes = {
	type: PropTypes.oneOf([
		'broadcast',
		'performances',
		'events',
		'gallery',
		'tours',
		'infographic'
	]).isRequired,
	className: PropTypes.string,
	containerClassName: PropTypes.string,
	values: PropTypes.array.isRequired,
	instituteName: PropTypes.string,
	instituteId: PropTypes.number
};

export default MediaBlockIncut;
